import { InfoDialog } from '@strata/react-dialog';
import { DisplayRichText } from '@strata/react-rich-text-area';
import { type ComponentProps } from 'react';

import { type ReferralDetails } from 'store/api/treatmentApi';

interface NoticeDetailsDialogProps {
    copayDetails?: ReferralDetails['copayAssistanceMessage'];
    onSecondaryButtonClick: ComponentProps<typeof InfoDialog>['onClose'];
}

export const CopayNoticeDetailsDialog = ({
    copayDetails = undefined,
    onSecondaryButtonClick,
}: NoticeDetailsDialogProps) => (
    <InfoDialog
        dialogTitle={copayDetails?.title ?? ''}
        isOpen={!!copayDetails}
        onClose={onSecondaryButtonClick}
        dialogContent={
            copayDetails?.longMessage ? <DisplayRichText value={copayDetails?.longMessage} /> : null
        }
    />
);
